import styled, { css } from 'styled-components'

import type { Animation } from './Options'

export type AnimationDirection = 'backward' | 'forward'

type Props = {
	offset?: number
	height?: number

	phase: 'in' | 'out'
	animation?: Animation
}

const animatedOut = ({ out: { duration, keyframes } }: Animation) => css<Props>`
	position: absolute;
	top: ${({ offset }) => offset}px;
	left: 0;
	right: 0;
	height: ${({ height }) => height}px;
	z-index: 0;
	pointer-events: none;

	animation: ${keyframes} ${duration}s both ease-in-out;
`

const animatedIn = ({ in: { duration, keyframes } }: Animation) => css<Props>`
	animation: ${keyframes} ${duration}s both ease-in-out;
`

export const Wrapper = styled.div<Props>`
	flex-grow: 1;
	display: flex;
	flex-direction: column;
	z-index: 1;

	${({ animation, phase }) => {
		if (!animation) return ''

		switch (phase) {
			case 'in':
				return animatedIn(animation)
			case 'out':
				return animatedOut(animation)
		}
	}}
`
